import AnchorAPIError from './AnchorAPIError';

export type EpisodePerformanceResponse = {
  episodeId: number;
  kind: string;
  data: {
    rows: [number, string][];
  };
  columnHeaders: {
    name: string;
    type: string;
  }[];
};

export const fetchEpisodePerformanceUrl = (webEpisodeId: string) => (
  `/api/proxy/v3/analytics/episode/webEpisodeId:${webEpisodeId}/performance`
);

const fetchEpisodePerformance = async ({
  webEpisodeId,
}: {
  webEpisodeId: string;
}) => {
  const url = fetchEpisodePerformanceUrl(webEpisodeId);
  const response = await fetch(
    url,
    {
      credentials: 'same-origin',
    }
  );

  if (response.ok) {
    return response.json();
  }

  const { status, type } = response;
  throw new AnchorAPIError(
    response,
    `Non-200 response status: ${status} (${type})`
  );
};

export { fetchEpisodePerformance };
